/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Etat général du bien :\n- NEW : Neuf\n- GOOD : Bon\n- AVERAGE : Moyen\n- BAD : Mauvais\n
 */
export const propertyGeneralStateSchema = z.enum(["NEW", "GOOD", "AVERAGE", "BAD"]).default("GOOD").describe("Etat général du bien :\n- NEW : Neuf\n- GOOD : Bon\n- AVERAGE : Moyen\n- BAD : Mauvais\n")